import { Address } from 'api/definitions/address/types';

const reducer = (state: WtrState, action: { address: Address }) => ({
  ...state,
  selectedAddress: action.address,
});

export default reducer;
